// src/api/auth/authApi.js
import api from '../shared/AxiosConfig';

const login = (credentials) => api.post('/auth/login', credentials);
const register = (data) => api.post('/auth/register', data);
const logout = () => api.post('/auth/logout');
const refreshToken = (token) => api.post('/auth/generateToken', { refreshToken: token });
// const requestPasswordReset = (email) => api.post('/auth/forgot-password', { email });
const requestPasswordReset = (data) => api.post('/auth/forgot-password', data);

// authApi.js
const verifyResetCode = ({ email, code }) => api.post('/auth/verify-reset-code', { email, code });
const resetPassword = ({email, newPassword}) => api.post('/auth/reset-password', { email, newPassword });
// const sendResetCode = (data) => api.post('/auth/forgot-password', data);
const sendEmailVerification = () => api.post('/auth/send-email-verification');

// ✅ Yeni eklenen: Email doğrulama token’ını backend'e gönderme
const verifyEmail = (token) => api.post('/auth/verify-email', { token });

export const authApi = {
    login,
    register,
    logout,
    refreshToken,
    requestPasswordReset,
    verifyResetCode,
    resetPassword,
    sendEmailVerification,
    verifyEmail,
};
